import { Button, Chip } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import React, { useEffect, useState, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Headline from '../../components/headline/headline';
import Paragraph from '../../components/paragraph/paragraph';
import { useStyles } from './sectionCarList.jss';
import { setStepper } from '../../actions';
import { stepperOpen } from '../../commons/gtm-events';

const Icon = lazy(() => import('../../components/icon/icon'));

const CarListItem = ({
  classes,
  city,
  dealerName,
  fuelType,
  gearboxType,
  imageUrl,
  locationId,
  modelName,
  models,
  street,
  translations: {
    carListReservation: { buttonCTA },
    engines,
    stepperShort,
    stepperLong
  },
  vehicleId,
  versionName,
  vin,
  bir,
  engineType,
  setStepData,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentModel = models?.find((item) => item.modelName === modelName);
  const itemList = [
    { name: versionName, svg: 'Version' },
    { name: gearboxType, svg: 'Gearbox' },
    { name: fuelType, svg: 'Fuel' }
  ];


  const createListItem = ({ name, svg }, index) => (
    <ListItem classes={{ root: classes.listItem }} disableGutters key={index}>
      <ListItemIcon classes={{ root: classes.listItemIcon }}>
        <Icon id={svg} size={30} color="#000" />
      </ListItemIcon>
      <ListItemText classes={{ root: classes.listItemText }} primary={name} />
    </ListItem>
  );

  const createListDealer = (city, dealerName, street, index) => (
    <ListItem
      disableGutters
      classes={{
        root: classes.listItem
      }}
      alignItems="flex-start"
    >
      <ListItemIcon
        classes={{
          root: classes.listItemIcon
        }}
      >
        <Icon id="Geoloc" size={25} color="#000" />
      </ListItemIcon>
      <ListItemText
        classes={{ root: classes.listItemText }}
        disableTypography
        primary={
          <>
            <Paragraph textAlign="left" fontWeight={700} variant="body1">
              {dealerName}
              <br />
              {street}
              <br />
              {city}
            </Paragraph>
          </>
        }
      />
    </ListItem>
  );

  const engineTranslation = engines[engineType.toLowerCase()];

  const nextStep = () => {
    dispatch(setStepper(stepperLong));
    dispatch(
      setStepData({
        step_1: {
          locationId,
          vehicleId
        }
      })
    );
    stepperOpen({
      dealerName,
      dealerId: bir,
      vehicleModel: modelName,
      vehicleId,
      formType: 'test_drive_booking'
    })
    history.push({
      pathname: `/kalendarz/${vin}`,
      state: {
        locationId,
        vehicleId,
        modelName,
        slug: currentModel?.slug
      }
    });
  };

  const formStep = () => {
    dispatch(setStepper(stepperShort));
    dispatch(
      setStepData({
        step_1: {
          locationId,
          vehicleId
        }
      })
    );
    stepperOpen({
      dealerName, 
      dealerId: bir,
      vehicleModel: modelName,
      vehicleId,
      formType: 'test_drive_request'
    })
    history.push({
      pathname: `/formularz/${vin}`,
      state: {
        locationId,
        vehicleId,
        modelName,
        vin,
        slug: currentModel?.slug
      }
    });
  };

  return (
    <Grid item xs={12} className={classes.carListItemWrap} id="SectionCarList">
      {engineTranslation && (
        <Chip className={classes.chip} label={engineTranslation} variant="outlined" />
      )}
      <Grid container item xs={12} sm={4} alignItems="center">
        <img className={classes.carListItemImg} src={imageUrl} alt={modelName} />
      </Grid>
      <Grid item xs={12} sm={9} className={classes.carDetailsWrap}>
        <Headline
          className={classes.carDetailsModelName}
          headline={modelName}
          variant="h2"
          textAlign="left"
          xsTextAlign="center"
        ></Headline>
        <div className={classes.carDetailsList}>
          <Grid item xs={12} sm={process.env.REACT_APP_BRAND === 'dacia' ? 5 : 6}>
            <List disablePadding>{itemList.map((item, index) => createListItem(item, index))}</List>
          </Grid>
          <Grid item xs={12} sm={process.env.REACT_APP_BRAND === 'dacia' ? 7 : 6}>
            <List disablePadding>{createListDealer(city, dealerName, street)}</List>
            {process.env.REACT_APP_BRAND === 'dacia' ? (
              <Grid item xs={12} className={classes.carReservationDaciaWrap}>
                <Button
                  className={classes.carReservationButton}
                  classes={{ label: classes.carReservationLabel }}
                  fullWidth
                  color="primary"
                  variant="contained"
                  onClick={nextStep}
                  type="button"
                >
                  {buttonCTA}
                  <Icon id="Year" size="24" color="white" marginLeft={2} />
                </Button>
              </Grid>
            ) : null}
          </Grid>
        </div>
        {process.env.REACT_APP_BRAND === 'renault' ? (
          <Grid item xs={12} className={classes.carReservationWrap}>
            <div className={classes.carReservationButton}>
              <Button
                classes={{ label: classes.carReservationLabel }}
                fullWidth
                color="primary"
                variant="contained"
                onClick={nextStep}
                type="button"
              >
                {buttonCTA}
              </Button>
              dealer potwierdzi wybrany termin
            </div>
            <div className={classes.carReservationButton}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={formStep}
                type="button"
              >
                ustal termin jazdy później
              </Button>
              dealer skontaktuje się i zaproponuje termin
            </div>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};

function SectionCarList({
  actions: { fetchVehicles, setStepData },
  translations: {
    labelRowsPerPage,
    labelVehiclesCount,
    carListReservation,
    engines,
    stepperShort,
    stepperLong
  },
  name
}) {
  const classes = useStyles();
  const { vehicleList, models } = useSelector((state) => state.carBooking);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginationCount, setPaginationCount] = useState();
  const currentPages = Math.ceil(vehicleList.allVehiclesCounter / rowsPerPage);
  const scrollToSection = () => {
    setTimeout(
      () =>
        document.getElementById('SectionCarList')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        }),
      100
    );
  };

  const handleChangePageParams = ({ pageIndex, pageSize }) => {
    dispatch(fetchVehicles({ pageIndex: pageIndex, pageSize: pageSize }));
    scrollToSection();
  };

  const handleChangePage = (_, pageIndex) => {
    handleChangePageParams({ pageIndex: pageIndex - 1, pageSize: rowsPerPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    handleChangePageParams({ pageIndex: 0, pageSize: event.target.value });
  };

  useEffect(() => {
    setPaginationCount(currentPages);
  }, [currentPages]);

  useEffect(() => {
    setCurrentPage(vehicleList.pageIndex);
  }, [vehicleList]);

  return (
    <Box
      name={name}
      bgcolor="background.gray"
      component="div"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      textAlign="center"
      alignItems="center"
      pt={5}
      pb={7}
    >
      {vehicleList?.vehicles?.length && (
        <>
          <Box px={2} id="SectionCarList">
            <Paragraph className={classes.carListVehiclesCount} variant="subtitle2">
              {labelVehiclesCount}
              <strong> {vehicleList?.allVehiclesCounter}</strong>
            </Paragraph>
          </Box>
          <Grid container justifyContent="center" className={classes.carListWrap}>
            {vehicleList?.vehicles.map((car, index) => (
              <CarListItem
                models={models}
                classes={classes}
                key={index}
                translations={{ carListReservation, engines, stepperLong, stepperShort }}
                setStepData={setStepData}
                {...car}
              />
            ))}
            <Grid container className={classes.paginationWrap}>
              <Box
                display={{ xs: 'none', sm: 'flex' }}
                width={1 / 3}
                ml={2}
                flexDirection="row"
                alignItems="center"
              >
                <Paragraph className={classes.paginationLabel} fontWeight={700}>
                  {labelRowsPerPage}
                </Paragraph>
                {vehicleList?.allVehiclesCounter > 0 && (
                  <FormControl classes={{ root: classes.rowsPerPageSelect }}>
                    <Select
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      IconComponent={(props) => (
                        <KeyboardArrowDownIcon
                          className={[classes.rowsPerPageIcon, props.className]}
                        />
                      )}
                    >
                      {[10, 20, 30].map((item, key) => (
                        <MenuItem key={key} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
              <Pagination
                classes={{
                  ul: classes.paginationList
                }}
                count={paginationCount}
                onChange={handleChangePage}
                siblingCount={0}
                boundaryCount={1}
                page={currentPage + 1}
                disabled={paginationCount < 2}
                renderItem={(item) => (
                  <PaginationItem
                    classes={{
                      page: classes.paginationItemPage,
                      selected: classes.paginationItemSelected,
                      icon: classes.paginationItemIcon,
                      ellipsis: classes.paginationItemEllipsis
                    }}
                    {...item}
                  />
                )}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
}

export default SectionCarList;
